import { VOUCHER_REQUEST, VOUCHER_SUCCESS, VOUCHER_FAILURE } from '../actions/types';

const initialState = {
  isLoading: false,
};

export default function voucherReducer(state = initialState, action = {}) {
  switch (action.type) {
    case VOUCHER_REQUEST: {
      return {
        ...state,
        isLoading: true,
      };
    }
    case VOUCHER_SUCCESS: {
      const {
        id,
        amount,
        currency_code: currencyCode,
        currency_symbol: currencySymbol,
        description,
        redemption_code: redemptionCode,
      } = action.payload;

      return {
        ...state,
        isLoading: false,
        id,
        amount,
        currencyCode,
        currencySymbol,
        description,
        redemptionCode,
      };
    }
    case VOUCHER_FAILURE: {
      return {
        ...state,
        isLoading: false,
      };
    }
    default:
      return state;
  }
}
